<template>
<div>

    <el-crud :baseUrl="'/employees/'+id+'/records'" 
        v-model="resource"
        :actions="[]"
        :config="crudConfig"
        :filters="filters"
        ref="crud">


        <template slot="crudFiltersDescription">
            <div>Fecha: <strong>{{filters.date_from}}</strong> a <strong>{{filters.date_to}}</strong></div>
        </template>

        <template slot="crudFiltersForm">
            <el-form-item label="Fechas" prop="date_range" required :rules="[{required: true, message: 'Campo requerido'}]">
                <el-date-picker
                    v-model="filters.date_range"
                    type="daterange"
                    @change="dateRangePickerChange"
                    format="yyyy-MM-dd"
                    align="right"
                    placeholder="Seleccione una fecha">
                </el-date-picker>
            </el-form-item>
        </template>

        <template slot="table">
            <el-table-column type="expand">
                <template slot-scope="scope">
                    <el-row :gutter="20">
                        <el-col :span="8"><div><strong>Registros del Día</strong></div>
                            <table class="details">
                                <tr v-for="(item, key) in scope.row.raw" :key="'dr' + key">
                                    <td><strong>{{devices[item.D]}}:&nbsp;</strong></td>
                                    <td>{{item.T}}</td>
                                </tr>
                            </table>
                        </el-col>
                        <el-col :span="8"><div><strong>Registros de la Jornada</strong></div>
                            <table class="details">
                                <tr v-for="(item, key) in scope.row.workday" :key="'wdr' + key">
                                    <td><strong>{{devices[item.D]}}:&nbsp;</strong></td>
                                    <td style="text-align:right"><span v-if="scope.row.date != item.T.substr(0, 10)">(+1) </span>{{item.T.substr(11)}}</td>
                                </tr>
                            </table>
                        </el-col>
                        <el-col :span="8"><div><strong>Horas Computadas</strong></div>
                            <table class="details">
                                <tr v-for="(val, key) in scope.row.computed.hours" :key="'h' + key">
                                    <td><strong>{{key}}:&nbsp;</strong></td>
                                    <td style="text-align:right">{{val}}</td>
                                </tr>
                            </table>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
            <el-table-column
                prop="date"
                label="Fecha">
            </el-table-column>
            <!-- <el-table-column
                prop="functional_area_description"
                label="Área">
            </el-table-column> -->
            <el-table-column
                prop="computed.shift"
                label="Turno">
            </el-table-column>
            <el-table-column
                prop="computed.in"
                label="Entrada">
            </el-table-column>
            <el-table-column
                prop="computed.out"
                label="Salida">
            </el-table-column>
            <el-table-column
                label="Total">
                <template slot-scope="scope">
                    {{scope.row.computed.total}}
                </template>
            </el-table-column>
            <el-table-column
                label="Extra">
                <template slot-scope="scope">
                    {{scope.row.computed.overtime}}
                </template>
            </el-table-column>
<!--             <el-table-column
                label="Alertas">
                <template scope="scope">
                    {{scope.row.pivot.date_to}}
                </template>
            </el-table-column> -->
        </template>

        <template slot="form" slot-scope="scope">
            <el-form-item label="Dispositivo" label-width="100px" :error="scope.errors.record">
                <el-select v-model="resource.device_id" filterable placeholder="Seleccione" size="mini">
                    <el-option
                        v-for="item in devicesOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Fechas" label-width="100px">
                <el-date-picker
                    v-model="resource.date_time.value"
                    type="datetime"
                    placeholder="Fecha y hora">
                </el-date-picker>
            </el-form-item>
        </template>
    
    </el-crud>

</div>
</template>

<style>
table.details td {
    padding-left: 3px;
    padding-right: 3px;
    font-size: 11px;
    line-height: 1.3em;
    height: 15px;
}
</style>

<script>
    import el_crud from '../el-crud.vue';
    export default {
        name: 'employee-records',
        props: {
            id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                employee_id: null,
                crudConfig:{
                    level: 'L2',
                    // AddItemTitle: 'Agregar registro',
                    // DeleteItemConfirmMessage: 'Esto borrará permanentemente la asignación al turno. Desea continuar?'
                },
                resource: {
                    device_id: null,
                    date_time: {
                        value: '',
                        setValue: (value) => {
                            this.resource.date_time.value = '';
                        },
                        getValue: () => {
                            return moment(this.resource.date_time.value).format('YYYY-MM-DD HH:mm:SS');
                        }
                    },
                },
                devicesOptions: [],
                devices: {},
                // functional_areas: [],
                filters: {
                    // functional_area_id: null,
                    // filter: null,
                    date_range: null,
                    date_from: null,
                    date_to: null,
                },
            };
        },
        components: {
            'el-crud': el_crud,
        },
        // computed: {
        //     'functional_area_name': function () {
        //         let item = _.find(this.functional_areas, (item) => {return item.value == this.filters.functional_area_id});
        //         if (item != undefined) {
        //             return item.label;
        //         } else {
        //             return '-';
        //         }
        //     }
        // },
        mounted() {
            // axios.get('/api/functionalareas/options').then((response) => {
            //     this.functional_areas = [{label: 'Todas', value: null}];
            //     _.each(response.data, (description, id) => {
            //         this.functional_areas.push({label: description, value: id})
            //     });
            // });
            axios.get('/api/devices/options').then((response) => {
                _.each(response.data, (description, id) => {
                    this.devicesOptions.push({label: description, value: id})
                    this.devices[id] = description;
                });
                // _.each(response.data, (description, id) => {
                //     this.devices[id] = description;
                // });
            });
        },
        methods: {
            dateRangePickerChange () {
                let value = this.filters.date_range;
                // console.log(value);
                this.filters.date_from = moment(value[0]).format('YYYY-MM-DD');
                this.filters.date_to = moment(value[1]).format('YYYY-MM-DD');
            },
        }
    }
</script>
